'use client';

import { useEffect } from 'react';
import { useRollbar } from '@rollbar/react';

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

/**
 * Route-level error boundary for the App Router.
 *
 * Catches unhandled render errors inside any nested segment
 * (booking flow, auth, customer, etc.), reports them to Rollbar, and
 * offers the user a retry button that re-mounts the segment.
 *
 * @param error - The error thrown by React during render.
 * @param reset - Callback that re-renders the failed segment.
 */
export default function Error({ error, reset }: Props) {
  const rollbar = useRollbar();

  useEffect(() => {
    rollbar.error(error);
  }, [error, rollbar]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-6 text-center">
      <h2 className="mb-4 text-xl font-semibold">Something went wrong.</h2>
      <button
        onClick={() => reset()}
        className="rounded bg-black px-4 py-2 text-white"
      >
        Try again
      </button>
    </div>
  );
}
